import { LinearProgress, Paper } from '@material-ui/core'
import cx from 'clsx'
import Downshift, { DownshiftState, StateChangeOptions } from 'downshift'
import { FormEvent, useCallback, useEffect, useRef, useState } from 'react'
import { Subject } from 'rxjs'

import { detectMessage } from './detect-message'
import { IncrementalSearch, now } from './IncrementalSearch'
import { FAQ, SearchProps } from './interface'
import { renderInput, renderSuggestion } from './renderer'

export function Search({ search, onSearched, onClick, searchWaitMs, resultMessage }: SearchProps) {
  const [menuIsOpen, setMenuIsOpen] = useState(false)
  const [submit$, setSubmit$] = useState<Subject<number>>()

  const timer = useRef<number | null>(null)
  useEffect(() => {
    const s = new Subject<number>()
    // s.next(now())
    setSubmit$(s)
    return () => s.unsubscribe()
  }, [])
  useEffect(() => {
    return () => {
      if (timer.current) {
        clearTimeout(timer.current)
      }
    }
  }, [])
  // const updateValue = setValue
  const reducer: (
    state: DownshiftState<any>,
    changes: StateChangeOptions<any>
  ) => Partial<StateChangeOptions<any>> = (state, changes) => {
    // console.log(state, changes)
    switch (changes.type) {
      case Downshift.stateChangeTypes.changeInput: {
        const open = !changes.inputValue || changes.inputValue.length < 2 ? false : true
        setMenuIsOpen(open)
        return {
          ...changes,
          isOpen: open,
        }
      }
      case Downshift.stateChangeTypes.blurInput:
      case Downshift.stateChangeTypes.mouseUp:
        return {
          ...changes,
          inputValue: state.inputValue,
          isOpen: state.isOpen,
        }
      case Downshift.stateChangeTypes.keyDownEnter:
        return {
          ...changes,
          inputValue: state.inputValue,
        }

      default:
        return changes
    }
  }
  const handleSubmit = useCallback(
    (e: FormEvent) => {
      e.preventDefault()
      setMenuIsOpen(true)
      setTimeout(() => {
        if (submit$) {
          submit$.next(now())
        }
      }, 100)
      // console.log('submit')
    },
    [submit$]
  )
  const handleOuterClick = useCallback(() => {
    if (timer.current !== null) {
      window.clearTimeout(timer.current)
    }
    timer.current = window.setTimeout(() => setMenuIsOpen(false), 150)
  }, [])
  const handleSelect = (
    item: FAQ | null,
    state: { inputValue?: string | null },
    queryFAQ: FAQ[]
  ) => {
    if (!item) {
      return
    }
    onSearched(state.inputValue || '', queryFAQ)
    onClick(`/answer/${item.id}?query=${encodeURIComponent(state?.inputValue || '')}`)
  }
  return (
    <Downshift<FAQ>
      id="downshift-simple"
      isOpen={menuIsOpen}
      onOuterClick={handleOuterClick}
      stateReducer={reducer}
      itemToString={item => item?.title || ''}
    >
      {({ getInputProps, getItemProps, getMenuProps, highlightedIndex, isOpen, inputValue }) => (
        <form className="faq-search-container" onSubmit={handleSubmit}>
          {renderInput({
            InputProps: getInputProps({
              placeholder: '質問内容をご入力ください',
            }) as any,
          })}
          <div {...getMenuProps()}>
            {isOpen && submit$ ? (
              <IncrementalSearch
                inputValue={inputValue || ''}
                submit$={submit$}
                search={search}
                searchWaitMs={searchWaitMs}
                onSearched={onSearched}
              >
                {({ data, done, error }) => {
                  if (!data || !data.queryFAQ) {
                    return <></>
                  }
                  if (data.queryFAQ.length === 0 && !!inputValue) {
                    return done ? (
                      <Paper
                        className={cx('faq-search-result', 'faq-search-container__paper')}
                        square
                      >
                        <p className="faq-search-result__message">
                          {detectMessage(error, resultMessage)}
                        </p>
                      </Paper>
                    ) : (
                      <Paper
                        className={cx('faq-search-result', 'faq-search-container__paper')}
                        square
                      >
                        <LinearProgress className="faq-search-container__paper__progress" />
                      </Paper>
                    )
                  }
                  const { queryFAQ = [] } = data
                  return (
                    <Paper
                      className={cx('faq-search-result', 'faq-search-container__paper')}
                      square
                    >
                      {queryFAQ.map((suggestion, index) =>
                        renderSuggestion({
                          suggestion,
                          index,
                          highlightedIndex,
                          inputValue,
                          itemProps: getItemProps({
                            item: suggestion,
                          }),
                          onClick: (item: FAQ) => handleSelect(item, { inputValue }, queryFAQ),
                        })
                      )}
                    </Paper>
                  )
                }}
              </IncrementalSearch>
            ) : null}
          </div>
        </form>
      )}
    </Downshift>
  )
}
